import React from 'react';

const brands = [
  { name: 'Pfizer', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Pfizer_logo.svg/200px-Pfizer_logo.svg.png' },
  { name: 'Johnson & Johnson', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Johnson_%26_Johnson_logo.svg/200px-Johnson_%26_Johnson_logo.svg.png' },
  { name: 'Bayer', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Logo_Bayer.svg/200px-Logo_Bayer.svg.png' },
  { name: 'Novartis', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Novartis-Logo.svg/200px-Novartis-Logo.svg.png' },
  { name: 'Abbott', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Abbott_Laboratories_logo.svg/200px-Abbott_Laboratories_logo.svg.png' },
  { name: 'GSK', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/GSK_logo_2022.svg/200px-GSK_logo_2022.svg.png' },
];

const TrustedBrands = () => {
  return (
    <section className="py-12 bg-gray-50 border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8">
          <p className="text-gray-500 text-sm font-medium uppercase tracking-wider">
            Trusted by Leading Healthcare Brands
          </p>
        </div>
        
        {/* Scrolling Brands */}
        <div className="relative overflow-hidden">
          <div className="flex animate-scroll gap-12 items-center">
            {[...brands, ...brands].map((brand, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-32 h-16 flex items-center justify-center grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="max-w-full max-h-full object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <span className="hidden text-gray-600 font-semibold text-lg">{brand.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default TrustedBrands;
